import ReactGA from "react-ga4";

const TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID; // 環境変数から取得
const isProduction = process.env.NODE_ENV === "production"; // 本番環境の判定

if (isProduction && TRACKING_ID) {
  ReactGA.initialize(TRACKING_ID);
}

export const trackPageView = (path) => {
  if (isProduction && TRACKING_ID) {
    ReactGA.send({ hitType: "pageview", page: path });
  }
};

export const trackEvent = (category, action, label) => {
  if (isProduction && TRACKING_ID) {
    ReactGA.event({ category, action, label });
  }
};
